<template>
  <div class="TitleName">
      <p>{{name}}</p>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'TitleName',
  props: ['name'],
  data () {
    return {}
  },
  mounted () {},
  methods: {
       ...mapActions([
            'setLoading'
        ])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
      
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.TitleName {
    p {
        position: relative;
        font-size: 18px;
        font-weight: bold;
        color: #2B5278;
        &::before {
            content: '';
            display: block;
            position: absolute;
            bottom: -8px;
            left: 12px;
            width: 30px;
            height: 2px;
            background: #2E7FFF;
        }
        &::after {
            content: '';
            display: block;
            position: absolute;
            bottom: -8px;
            left: 0;
            width: 6px;
            height: 2px;
            background: #2E7FFF;
        }
    }
}
</style>